import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { environment } from '../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { CommonAccessTokenService } from '../services/common-access-token.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private storageService: StorageService, private route: ActivatedRoute, private accessTokenService: CommonAccessTokenService) {}

  private prepareHttpOptions(backend: 'mms' | 'pool' | 'admin'): HttpHeaders {
    const headerObj: { [key: string]: string } = {};

    const accessToken = this.accessTokenService.getAccessTokenFromUrl();

    if (accessToken && backend === 'pool') {
      headerObj['X-API-ACCESSTOKEN'] = `${accessToken}`;
    } else {
      let token = '';

      if (backend === 'admin') {
        token = this.storageService.getAdminToken() || '';
        headerObj['X-Api-Token'] = `${token}`;
      } else if (backend === 'pool') {
        token = this.storageService.getToken() || '';
        headerObj['X-API-TOKEN'] = `${token}`;
      } else if (backend === 'mms') {
        token = this.storageService.getTokenMms() || '';
        headerObj['Authorization'] = `${token}`;
      }
    }

    return new HttpHeaders(headerObj);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.indexOf(environment.poolApi + '/admin') !== -1) {
      const headers = this.prepareHttpOptions('admin');
      const authReq = req.clone({ headers });
      return next.handle(authReq);
    } else if (req.url.indexOf(environment.poolApi) !== -1) {
      const headers = this.prepareHttpOptions('pool');
      const authReq = req.clone({ headers });
      return next.handle(authReq);
    } else if (req.url.indexOf(environment.mmsApi) !== -1) {
      const headers = this.prepareHttpOptions('mms');
      const authReq = req.clone({ headers });
      return next.handle(authReq);
    } else {
      return next.handle(req);
    }
  }
}
